import { render } from "./PosterUploadForm.vue?vue&type=template&id=5d4a922a&scoped=true"
import script from "./PosterUploadForm.vue?vue&type=script&lang=js"
export * from "./PosterUploadForm.vue?vue&type=script&lang=js"

import "./PosterUploadForm.vue?vue&type=style&index=0&id=5d4a922a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_typescript@7.0.2__webpack@5.111.0_postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4a922a"]])

export default __exports__